import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ErrorMessageService } from 'src/app/services/error-message/error-message.service';

@Component({
  selector: 'app-error-alert',
  templateUrl: './error-alert.component.html',
  styleUrls: ['./error-alert.component.scss'],
})
export class ErrorAlertComponent implements OnInit, OnDestroy {
  messages: Array<string> = [];

  private subscriptions: Array<Subscription> = [];

  constructor(private errorMessageService: ErrorMessageService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.errorMessageService.errorMessages.subscribe(
        (data: Array<string>) => {
          this.messages = [...data];
        }
      )
    );
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }

  onClose(message: string) {
    this.errorMessageService.clearIndividualMessage(message);
  }
}
